import React from 'react'
import { tokens } from '@/locales/translations/tokens'
import { ExternalLink } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import FileIcon from '@/utils/file-extension-icons'
import { Button } from '@/components/ui/button'
import { Markdown } from '../../../markdown'

interface DocumentContentProps {
  title: string
  content?: string
  summary?: string
  sourceUrl?: string
}

export const DocumentContent: React.FC<DocumentContentProps> = ({
  title,
  content,
  summary,
  sourceUrl,
}) => {
  const { t } = useTranslation()
  const textContent = content?.trim() || summary?.trim() || ''

  if (!textContent) {
    return (
      <div className='flex min-h-[320px] items-center justify-center rounded-3xl border border-dashed border-border/70 bg-muted/20 p-8'>
        <div className='flex max-w-md flex-col items-center gap-4 text-center'>
          <div className='flex h-20 w-20 items-center justify-center rounded-2xl bg-background shadow-sm'>
            <FileIcon fileName={title} size={40} className='h-10 w-10' />
          </div>

          <div className='space-y-2'>
            <h3 className='text-lg font-semibold text-foreground'>{title}</h3>
            {sourceUrl && (
              <Button asChild variant='outline' className='gap-2'>
                <a href={sourceUrl} target='_blank' rel='noopener noreferrer'>
                  {t(tokens.workstation.sources.goToSource)}
                  <ExternalLink size={14} />
                </a>
              </Button>
            )}
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className='prose prose-sm dark:prose-invert max-w-none'>
      <Markdown>{textContent}</Markdown>
    </div>
  )
}
